import { render } from "./IconRampRight.vue?vue&type=template&id=697343ca"
import script from "./IconRampRight.vue?vue&type=script&lang=js"
export * from "./IconRampRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__